import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleAlert } from './../json-form/formSlice';

export default function AlertDialog(props) {
  const dispatch = useDispatch();
  const { showAlert } = useSelector(state => state.form)

  const handleClose = () => {
    if(props.onClose === null) {
      dispatch(toggleAlert())
    } else {
      props.onClose.call();
    }
  };

  return (
    <div>
      <Dialog
        open={showAlert}
        disableBackdropClick={true}
        disableAutoFocus={true}
        disableEscapeKeyDown={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{props.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
